import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import setAuthorization from '../utils/helpers/setAuthorization'
import { API_BASE_URL } from '../constants/api'

const trailsRepository = createApi({
	reducerPath: 'trailsRepository',
	baseQuery: fetchBaseQuery({
		prepareHeaders: setAuthorization,
		baseUrl: API_BASE_URL,
	}),
	tagTypes: ['Trails'],
	endpoints: (builder) => ({
		getMatriculate: builder.query<
			Array<{
				id: number
				nome: string
				status: string
				empresa_id: number
				available_courses: Array<{
					id: number
					name: string
					'type-course': string
					ordem: number
					turma: {
						id: number
						curso_id: number
						empresa_id: number
						status: string
					}
					produto_nome: string
					categoria: string
				}>
			}>,
			{ userId: number }
		>({
			query: ({ userId }) => ({
				url: `/v1/trails/${userId}/cursos-disponiveis`,
				method: 'GET',
			}),
			providesTags: ['Trails'],
		}),
	}),
})

export default trailsRepository
